import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class TourManager extends React.Component {
  constructor(props) {
    super(props);
    this.handleSend = this.handleSend.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  handleRemove(e) {
    e.preventDefault();
    this.props.removeTourManager(this.props.tourId, { user: this.props.tourManager.id });
  }
  handleSend(e) {
    this.props.sendToTourManager(this.props.tourId, { user: this.props.tourManager.id });
  }
  buildToolbar() {
    if (this.props.readOnly) {
      return null;
    }
    return (
      <span className="pull-right">
        <Button onClick={this.handleSend}><i className="fa fa-envelope" /></Button>
        <Button onClick={this.handleRemove}><i className="fa fa-trash" /></Button>
      </span>
    );
  }
  render() {
    const tourManager = this.props.tourManager;
    const toolbar = this.buildToolbar();
    if (tourManager) {
      if (tourManager.first_name) {
        return (
          <p className="clearfix">{tourManager.first_name} {tourManager.last_name} {toolbar}</p>
        );
      }
      return (<p className="clearfix">{tourManager.email} {toolbar}</p>);
    }
    return (
      <p>
        Tour Manager missing.
      </p>
    );
  }
}
TourManager.propTypes = {
  tourId: PropTypes.number.isRequired,
  tourManager: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  removeTourManager: PropTypes.func.isRequired,
  sendToTourManager: PropTypes.func.isRequired,
};
export default TourManager;



// WEBPACK FOOTER //
// src/routes/tours/components/TourManager.js